/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class RecommendationButton extends Component {
  render() {
    const { button, recommendation, callExternalAPI, clickedLink, loading, app } = this.props;

    let conditional_classes = ' ';
    if (app.id === 'web') conditional_classes += 'ml-2';
    if (app.id === 'chrome') conditional_classes += 'mr-1';

    let button_text = button.text;

    if (loading) {
      conditional_classes += ' disabled';
      button_text = 'Sending request...';
    }

    if (button.type === 'external_api_call') {
      return (
        <a
          key={button.key}
          href="javascript:void(0);"
          className={`btn btn-secondary align-self-center${conditional_classes}`}
          onClick={() => callExternalAPI({ recommendation_id: recommendation.id, button_key: button.key })}
        >
          {button_text}
        </a>
      );
    }
    if (button.type === 'link') {
      return (
        <a
          target="_blank"
          onClick={() => clickedLink(button.key, button.link)}
          key={button.key}
          href={button.link}
          className={`btn btn-secondary align-self-center${conditional_classes}`}
          rel="noopener noreferrer"
        >
          {button_text}
        </a>
      );
    }
    return <div />;
  }
}

RecommendationButton.propTypes = {
  recommendation: PropTypes.object.isRequired,
  button: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const button_state_key = `recommendation:${ownProps.recommendation.id}:${ownProps.button.key}`;
  return {
    app: state.app,
    loading: !!state.button_states[button_state_key],
  };
};

export default connect(mapStateToProps)(RecommendationButton);
